// Banner global que aparece quando ha buracos na numeracao fiscal aguardando
// inutilizacao (numeros nao autorizados na SEFAZ que o contador aponta como
// "Notas nao lancadas de Saidas"). Fonte: GET /api/inutilizacoes/resumo — a mesma
// varredura do scheduler diario. Click leva pra Configuracoes > Fiscal >
// Inutilizacoes, onde o Ruan fecha com 1 clique. Laranja = pendencia (nao erro).
// Dispensavel por 1 dia via X. So admin/gerente (inutilizacao e admin/gerente).
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eraser, X } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useAlertaFaixa } from './alertas/AlertasContexto';

interface Resumo {
  total: number;
  candidatos: number;
  furos: number;
}

const POLLING_MS = 10 * 60 * 1000;
const KEY_DISMISS = 'buracos_numeracao.alerta.dismiss';

function dismissedHoje(): boolean {
  return localStorage.getItem(KEY_DISMISS) === new Date().toISOString().slice(0, 10);
}

export function AlertaBuracosNumeracaoBanner() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [resumo, setResumo] = useState<Resumo | null>(null);
  const [dismissed, setDismissed] = useState(dismissedHoje);

  const podeVer = usuario && ['admin', 'gerente'].includes(usuario.perfil);

  useEffect(() => {
    if (!podeVer) return;
    let cancelado = false;
    async function tick() {
      try {
        const r = await api.get<Resumo>('/api/inutilizacoes/resumo');
        if (!cancelado) setResumo(r);
      } catch {}
    }
    void tick();
    const id = setInterval(tick, POLLING_MS);
    return () => { cancelado = true; clearInterval(id); };
  }, [podeVer]);

  const ativo = !!(podeVer && !dismissed && resumo && resumo.total > 0);
  const recolhido = useAlertaFaixa(
    'buracos-numeracao',
    ativo ? { rotulo: 'Numeracao fiscal', bg: '#f97316', borda: '#c2410c', qtd: resumo!.total } : null,
  );

  if (!ativo || recolhido || !resumo) return null;

  const n = resumo.total;
  function fechar() {
    localStorage.setItem(KEY_DISMISS, new Date().toISOString().slice(0, 10));
    setDismissed(true);
  }

  return (
    <div
      style={{
        background: '#f97316',
        borderLeft: '4px solid #c2410c',
        color: '#000',
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 13,
        cursor: 'pointer',
      }}
      onClick={() => navigate('/configuracoes/fiscal?aba=inutil')}
    >
      <Eraser size={16} />
      <span style={{ fontWeight: 600 }}>Numeracao fiscal:</span>
      <span>
        {n} buraco{n === 1 ? '' : 's'} a fechar
        {resumo.furos > 0 && ` (${resumo.furos} pulado${resumo.furos === 1 ? '' : 's'} sem registro)`}
      </span>
      <span style={{ marginLeft: 'auto', textDecoration: 'underline' }}>Fechar buracos</span>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); fechar(); }}
        title="Dispensar ate amanha"
        style={{ background: 'transparent', border: 'none', color: '#000', cursor: 'pointer', padding: 2 }}
      >
        <X size={14} />
      </button>
    </div>
  );
}
